import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';

import { isOnMobile } from 'utils/device-utils';
import LanguageService from 'services/Language.service';

import messages from './GeneralMeetingsView.intl';
import generalMeetingsMdMessages from './GeneralMeetingsMd.intl';
import generalMeetingsSmMessages from './GeneralMeetingsSm.intl';

import { ANCHOR } from 'common/consts/common';
import { LOAD_STATES } from 'common/consts/common';

import { generateYearsFilterArray } from 'utils/date-utils';

//components
import ArticlesPage from 'common/components/ArticlesPage/ArticlesPage';
import PageNotFound from 'views/PageNotFound/PageNotFoundView';

import GeneralMeetingsStore from 'stores/GeneralMeetings.store';
import TaxonomyStore from 'stores/Taxonomy.store';
import { observer } from 'mobx-react';
import { observable, reaction, action, computed, runInAction } from 'mobx';
import ContentStore from 'stores/Content.store';

@injectIntl
@withRouter
@observer
export default class GeneralMeetingsView extends Component {
  taxonomies = TaxonomyStore;
  filtersList = generateYearsFilterArray({
    first: {
      text: this.props.intl.formatMessage(messages.filter),
      value: ''
    },
    from: 2021
  });

  state = {
    isMobile: isOnMobile(),
    selectedFilter: this.props.match.params.category
      ? this.filtersList.find(
          filter => filter.value === this.props.match.params.category
        )
      : this.filtersList[0]
  };

  criteria = observable({
    page: GeneralMeetingsStore.latestState.page,
    category: GeneralMeetingsStore.latestState.category,
    publishYear:
      this.state.selectedFilter || GeneralMeetingsStore.latestState.publishYear
  });

  latestNews = observable([]);
  loadState = observable.box('');
  isExploited = false;

  currentLanguage = LanguageService.getLang();

  async componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    reaction(() => this.criteria.category, () => this.latestNews.clear());
    reaction(() => this.criteria.publishYear, () => this.latestNews.clear());
  }

  componentWillUnmount() {
    if (!this.state.selectedFilter) {
      return;
    }

    GeneralMeetingsStore.latestState = {
      data: [...this.latestNews],
      page: this.criteria.page,
      isExploited: this.isExploited,
      category: this.criteria.category,
      publishYear: this.criteria.publishYear
    };

    window.removeEventListener('resize', this.updateDimensions);
  }

  @action
  updateCriteria(newCriteria) {
    Object.assign(this.criteria, newCriteria);
    this.fetchLatestGeneralMeetings(this.criteria);
  }

  @Bind()
  async showMore() {
    this.updateCriteria({
      page: this.criteria.page + 1
    });
  }

  async fetchLatestGeneralMeetings(criteria) {
    const { data } = await GeneralMeetingsStore.fetchLatestGeneralMeetings(
      criteria
    );

    runInAction(() => {
      this.latestNews.push(...data);
      GeneralMeetingsStore.latestState.data = [];
    });
  }

  @computed
  get criteriaKey() {
    return JSON.stringify(this.criteria);
  }

  @computed
  get isLoaded() {
    return this.loadState.get() === LOAD_STATES.LOADED;
  }

  render() {
    const { selectedFilter } = this.state;
    if (!this.state.selectedFilter) {
      return <PageNotFound />;
    }

    return (
      <ArticlesPage
        messages={messages}
        viewWithOnlyNews
        categorySlug={ANCHOR.GENERAL_MEETINGS}
        filtersList={this.filtersList}
        selectedFilter={selectedFilter}
        criteria={this.criteria}
        criteriaKey={this.criteriaKey}
        fetchLatestNews={this.fetchLatestGeneralMeetings}
        seoContent={
          ContentStore.content && ContentStore.content.generalMeetingsSEO
        }
        latestNews={this.latestNews}
        isExploited={this.isExploited}
        articleNoteMdMessages={generalMeetingsMdMessages}
        articleNoteSmMessages={generalMeetingsSmMessages}
        otherNews={GeneralMeetingsStore.otherCurrentReports}
        categoryPath="news.generalMeetingsCategory.value"
        withReturnToInvestors
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/GeneralMeetings/GeneralMeetingsView.js